<template>
    <div>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 102" id="el_Sy7lwuVOxp7">
   
    <defs/>
    <title>
        Agregale
    </title>
    <g id="el_Bk4gvdN_x6m" data-name="Capa 2">
        <g id="el_ByrxvuEueaQ" data-name="Capa 1">
            <path d="M51.1,0a51.11,51.11,0,1,0,51.11,51.1A51.16,51.16,0,0,0,51.1,0Z" id="circulo"/>
            <g id="hielos" class="hielo ">
                <path d="M79.35,53.18,71.19,33.57a2.58,2.58,0,0,0-1.41-1.4,2.55,2.55,0,0,0-2,0l-12.11,5-4.09-10a2.61,2.61,0,0,0-1.41-1.4,2.52,2.52,0,0,0-2,0L28.55,33.92a2.6,2.6,0,0,0-1.41,3.38L35.21,57a2.61,2.61,0,0,0,2.41,1.61,2.46,2.46,0,0,0,.53-.06L33.62,64A2.58,2.58,0,0,0,34,67.62L50.31,81.18a2.56,2.56,0,0,0,1.65.6h.25A2.6,2.6,0,0,0,54,80.84L67.52,64.49a2.57,2.57,0,0,0,.59-1.9,2.61,2.61,0,0,0-.77-1.6L78,56.58a2.58,2.58,0,0,0,1.4-1.41A2.55,2.55,0,0,0,79.35,53.18ZM36.58,56.39,28.5,36.74a1.14,1.14,0,0,1,.61-1.46L48.76,27.2a1.25,1.25,0,0,1,.42-.08,1.12,1.12,0,0,1,.44.09,1.1,1.1,0,0,1,.6.6l4.1,10-6.14,2.55a2.6,2.6,0,0,0-1.4,3.39l1.33,3.19,0,0c-.11.05-.21.12-.32.18l-.16.1a2.59,2.59,0,0,0-.41.4l-7.09,8.54L38,57A1.11,1.11,0,0,1,36.58,56.39Zm29.81,7.16L52.83,79.9a1.12,1.12,0,0,1-.76.4,1.15,1.15,0,0,1-.82-.25L34.9,66.49a1.12,1.12,0,0,1-.4-.76,1.1,1.1,0,0,1,.25-.82l6.35-7.65,7.21-8.7a1.16,1.16,0,0,1,.84-.39,1,1,0,0,1,.74.24l4,3.27,11.64,9.66h0l.76.63a1.12,1.12,0,0,1,.4.76A1.1,1.1,0,0,1,66.39,63.55ZM78,54.61a1.12,1.12,0,0,1-.61.6l-11.3,4.71-11.3-9.38-4-3.27a2.54,2.54,0,0,0-1.18-.49l-1.5-3.62a1.07,1.07,0,0,1,0-.86,1.09,1.09,0,0,1,.6-.61l7.49-3.11h0l12.12-5a1.16,1.16,0,0,1,.86,0,1.14,1.14,0,0,1,.61.61L78,53.75A1.16,1.16,0,0,1,78,54.61Z" id="el_HywxD_VOgpQ"/>
            </g>
            <g class="hielo " >
                <path d="M65.66,37.35l-3.29,1.37.57,1.36,3.29-1.37h0a1.29,1.29,0,0,1,.28-.08,1.15,1.15,0,0,1,1.15.61l0,.07,1.68,4,1.36-.56-1.68-4A2.59,2.59,0,0,0,65.66,37.35Z" id="el_HyOePdN_x67"/>
            </g>
            <g class="hielo" >
                <path d="M33.72,36.07a2.61,2.61,0,0,0-1.61,2.41,2.42,2.42,0,0,0,.2,1l1.66,4,1.36-.56-1.66-4a1.12,1.12,0,0,1,.61-1.46l3.3-1.36L37,34.72Z" id="el_HkYxP_4OgpX"/>
            </g>
            <g class="hielo" >
                <path d="M40.48,66a1.1,1.1,0,0,1-.4-.76.34.34,0,0,1,0-.1,1.09,1.09,0,0,1,.26-.71l2.27-2.75-1.13-.94-2.28,2.74a2.57,2.57,0,0,0-.59,1.66,1.93,1.93,0,0,0,0,.24v.06h0a2.59,2.59,0,0,0,.88,1.66l0,0,3.36,2.79,1-1.14L40.48,66Z" id="el_Sk5evuN_x6Q"/>
            </g>
        </g>
    </g>
</svg>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.bounce-in-top {
	-webkit-animation: bounce-in-top 1.1s both;
	        animation: bounce-in-top 1.1s both;
}

    #circulo{fill: #8f0028;}
    #hielos{fill: #fff;}
    .hielo{fill: #fff;}
 /* ----------------------------------------------
 * Generated by Animista on 2018-11-7 11:53:13
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
}


</style>